import { IconStatus, IconStatusTypes, Text, HStack, VStack } from '@genial/components';
import { Color, ColorTypes, Spacing, Typography } from '@genial/design-tokens';
import { IconographyTypes } from '@genial/icons';
import { Box } from 'native-base';
import React from 'react';
import { Svg, Path } from 'react-native-svg';

export namespace ProcessCardTypes {
  type InfoType = { label: string; value: string };

  export type StatusType = 'lock' | 'pending' | 'unlock' | 'confirm-lock';

  export interface DottedVerticalLine {
    height: number;
  }

  export type Props = {
    isLastItem: boolean;
    isFirstItem: boolean;
    info: InfoType[];
    title: string;
    iconName: string;
    iconColor: string;
    iconSize: string;
    iconBackground: string;
  };
}

const DottedVerticalLine = ({ height }: ProcessCardTypes.DottedVerticalLine) => (
  <Svg width={1} height={height} fill="none" viewBox={`0 0 1 ${height}`}>
    <Path stroke={Color['neutral.lightest']} strokeDasharray="2 2" d={`M.5 0v${height}`} />
  </Svg>
);

export const ProcessCard: React.FC<ProcessCardTypes.Props> = ({
  iconName,
  iconColor,
  iconSize,
  iconBackground,
  isLastItem,
  isFirstItem,
  info,
  title,
}) => {
  const lineHeight = 30 * info.length;

  return (
    <VStack testID="process-card" w={'full'}>
      <HStack space={Spacing['inline.nano']}>
        <Box w={Spacing['inline.xxs']} alignItems={'center'}>
          {iconName && iconColor && iconSize && iconBackground && (
            <IconStatus
              testId="status-icon"
              size={iconSize as IconStatusTypes.Sizes}
              icon={iconName as IconographyTypes.Option}
              color={isFirstItem ? iconColor : (Color['neutral.light'] as ColorTypes.Option)}
              bgColor={
                isFirstItem ? iconBackground : (Color['neutral.lightest'] as ColorTypes.Option)
              }
            />
          )}

          {!isLastItem && <DottedVerticalLine height={lineHeight} />}
        </Box>
        <VStack display={'flex'} flex={1}>
          <Box h={Spacing['inline.xxs']} justifyContent={'center'}>
            <Text
              variant="semibold"
              color={isFirstItem ? 'neutral.black' : 'neutral.medium'}
              fontSize={Typography['fontsize.md']}>
              {title}
            </Text>
          </Box>
          <VStack
            pt={Spacing['inline.xxxs']}
            display={'flex'}
            flex={1}
            space={Spacing['inline.nano']}>
            {info &&
              info.map((item) => (
                <HStack justifyContent={'space-between'} key={item.label}>
                  <Text
                    variant="regular"
                    color={isFirstItem ? 'neutral.dark' : 'neutral.medium'}
                    fontSize={Typography['fontsize.md']}>
                    {item.label}
                  </Text>
                  <Text
                    textAlign={'right'}
                    w={'50%'}
                    variant="regular"
                    color={isFirstItem ? 'neutral.dark' : 'neutral.medium'}
                    fontSize={Typography['fontsize.md']}>
                    {item.value}
                  </Text>
                </HStack>
              ))}
          </VStack>
        </VStack>
      </HStack>
    </VStack>
  );
};
